import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ModalRef } from '@freelancer/ui';
import { LoginOrSignup } from './login-signup-modal.model';

@Component({
  selector: 'app-login-signup-modal',
  template: `
    <app-login
      *ngIf="form === LoginOrSignup.LOGIN"
      (switchToSignup)="switchPage(LoginOrSignup.SIGNUP)"
      (success)="handleSuccess($event)"
    ></app-login>
    <app-signup
      *ngIf="form === LoginOrSignup.SIGNUP"
      (switchToLogin)="switchPage(LoginOrSignup.LOGIN)"
      (success)="handleSuccess($event)"
    ></app-signup>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginSignupModalComponent {
  LoginOrSignup = LoginOrSignup;

  @Input() form: LoginOrSignup = LoginOrSignup.LOGIN;

  constructor(private modalRef: ModalRef<LoginSignupModalComponent>) {}

  switchPage(form: LoginOrSignup) {
    this.form = form;
  }

  handleSuccess(user: number) {
    this.modalRef.close(user);
  }
}
